module.exports = __webpack_public_path__ + "images/f2dc11d13873b936bbd65709d489d9d82d73c58714621a66ef644d432dcc69b1.svg";